import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import HeaderSection from "../components/shared/HeaderSection";

const Packages = () => {
  return (
    <>
      {/* Services Section */}
      <section className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-100 text-gray-800">
        {/* Header Section */}
        <HeaderSection
          image="/images/bg-images/services-bg.jpeg"
          header="Packages"
          subHeader="Showcasing Our Commitment to Innovation Through Real-World Solutions"
        />

        {/* Main Content */}
        <div className="py-16 px-6">
          <h2 className="text-3xl sm:text-3xl font-extrabold pb-4 mb-8 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 text-center">
            Our Web Hosting Packages
          </h2>
          <div className="container mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Basic Package */}
            <div className="relative bg-white p-8 rounded-2xl shadow-xl border-t-8 border-blue-400 hover:scale-105 transition-transform duration-300">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-blue-400 text-white px-6 py-2 rounded-full font-bold shadow">
                Basic
              </div>
              <h3 className="text-xl font-bold mb-4 text-blue-700 text-center mt-6">
                Basic Hosting Package
              </h3>
              <p className="text-3xl font-extrabold text-blue-600 text-center mb-2">
                £2.99
                <span className="text-base font-medium text-gray-500">/mo</span>
              </p>
              <p className="text-gray-600 mb-6 text-center">
                Perfect for small websites and blogs.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-blue-400" />
                  <span>1 GB Storage</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-blue-400" />
                  <span>10 GB Bandwidth</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-blue-400" />
                  <span>1 Domain</span>
                </li>
              </ul>
              <Link
                to="/contact"
                className="block w-full text-center bg-gradient-to-br from-blue-600 to-purple-600 text-white px-4 py-2 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-colors duration-300"
              >
                Get Started
              </Link>
            </div>
            {/* Standard Package */}
            <div className="relative bg-white p-8 rounded-2xl shadow-xl border-t-8 border-purple-500 hover:scale-105 transition-transform duration-300">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-purple-500 text-white px-6 py-2 rounded-full font-bold shadow">
                Standard
              </div>
              <h3 className="text-xl font-bold mb-4 text-purple-700 text-center mt-6">
                Standard Hosting Package
              </h3>
              <p className="text-3xl font-extrabold text-purple-600 text-center mb-2">
                £6.99
                <span className="text-base font-medium text-gray-500">/mo</span>
              </p>
              <p className="text-gray-600 mb-6 text-center">
                Ideal for growing businesses and e-commerce sites.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-purple-500" />
                  <span>5 GB Storage</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-purple-500" />
                  <span>50 GB Bandwidth</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-purple-500" />
                  <span>5 Domains</span>
                </li>
              </ul>
              <Link
                to="/contact"
                className="block w-full text-center bg-gradient-to-br from-purple-500 to-blue-600 text-white px-4 py-2 rounded-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-colors duration-300"
              >
                Get Started
              </Link>
            </div>
            {/* Premium Package */}
            <div className="relative bg-white p-8 rounded-2xl shadow-xl border-t-8 border-yellow-400 hover:scale-105 transition-transform duration-300">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-yellow-400 text-white px-6 py-2 rounded-full font-bold shadow">
                Premium
              </div>
              <h3 className="text-xl font-bold mb-4 text-yellow-600 text-center mt-6">
                Premium Hosting Package
              </h3>
              <p className="text-3xl font-extrabold text-yellow-500 text-center mb-2">
                £14.99
                <span className="text-base font-medium text-gray-500">/mo</span>
              </p>
              <p className="text-gray-600 mb-6 text-center">
                Best for high-traffic websites and applications.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-yellow-400" />
                  <span>Unlimited Storage</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-yellow-400" />
                  <span>Unlimited Bandwidth</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <FaCheckCircle size={18} className="text-yellow-400" />
                  <span>Unlimited Domains</span>
                </li>
              </ul>
              <Link
                to="/contact"
                className="block w-full text-center bg-gradient-to-br from-yellow-400 to-purple-600 text-white px-4 py-2 rounded-lg font-semibold hover:from-yellow-500 hover:to-purple-700 transition-colors duration-300"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Web Development Packages Section */}
      <section className="bg-gradient-to-br from-blue-600 via-purple-600 to-blue-800 text-gray-100 py-16 px-6">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-3xl sm:text-3xl font-bold mb-6 text-white text-center">
            Our Web Development Packages
          </h2>
          <p className="text-md text-gray-300 mb-8 text-center">
            Scalable, Secure & Stunning Websites – Designed for Success
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Basic Package */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 text-blue-200">
                Basic Package
              </h3>
              <p className="text-2xl font-extrabold text-blue-200 mb-2 text-center">
                £250{" "}
                <span className="text-base font-medium text-gray-300">
                  one-time
                </span>
              </p>
              <ul className="space-y-2">
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    5 Pages Responsive Website
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Mobile Responsive Design
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Contact Form Integration
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Basic SEO Optimization
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">Social Media Links</span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Google Analytics Setup
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Basic Security Features
                  </span>
                </li>
              </ul>
            </div>

            {/* Standard Package */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 text-blue-200">
                Standard Package
              </h3>
              <p className="text-2xl font-extrabold text-blue-200 mb-2 text-center">
                £500{" "}
                <span className="text-base font-medium text-gray-300">
                  one-time
                </span>
              </p>
              <ul className="space-y-2">
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    10 Pages Responsive Website
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">Custom UI/UX Design</span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">Blog Integration</span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Advanced SEO & Performance Optimization
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Content Management System (CMS) Integration
                  </span>
                </li>
              </ul>
            </div>

            {/* Premium Package */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 text-blue-200">
                Premium Package
              </h3>
              <p className="text-2xl font-extrabold text-blue-200 mb-2 text-center">
                £1000{" "}
                <span className="text-base font-medium text-gray-300">
                  one-time
                </span>
              </p>
              <ul className="space-y-2">
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    20+ Pages Responsive Website
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Custom Features & Web Applications
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">E-commerce Ready</span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Payment Gateway Integration
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    API & Third-Party Integrations
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Advanced Security & Performance Enhancements
                  </span>
                </li>
                <li className="flex items-center space-x-2 text-gray-300">
                  <FaCheckCircle
                    size={18}
                    className="flex-shrink-0 text-blue-200"
                  />
                  <span className="leading-relaxed">
                    Priority Support & Maintenance
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Packages;
